import { ClimberCategory, ResultCategory, Role, RouteCategory } from './constants';

const API_BASE_URL = window.location.host.includes('localhost')
  ? 'http://localhost:8080'
  : '/api';

async function get(url: string) {
  const rawResponse = await fetch(`${API_BASE_URL}${url}`, {
    credentials: 'include',
  });

  const response = await rawResponse.json();

  if (!response?.success) {
    throw Error(response.error);
  }

  return response.data;
}

async function post(url: string, payload: any) {
  const rawResponse = await fetch(`${API_BASE_URL}${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const response = await rawResponse.json();

  if (!response?.success) {
    throw Error(response.error);
  }

  return response.data;
}

async function put(url: string, payload: any) {
  const rawResponse = await fetch(`${API_BASE_URL}${url}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const response = await rawResponse.json();

  if (!response?.success) {
    throw Error(response.error);
  }

  return response.data;
}

type GradingOverviewResponse = {
  climbers: Climber[];
  routeCount: Record<RouteCategory, number>;
  routesPerCategory: Record<RouteCategory, Record<ClimberCategory, number[]>>;
};

type RoleData = {
  email?: string;
  role: Role;
};

export async function fetchRole(): Promise<RoleData> {
  return await get(`/role`);
}

export async function fetchOverviewData(): Promise<GradingOverviewResponse> {
  return await get(`/gradingOverview`);
}

export async function fetchScore({
  climberId,
  route,
  routeCategory,
}: {
  climberId: string;
  route: number;
  routeCategory: RouteCategory;
}): Promise<RouteScore> {
  return await get(
    `/score/${routeCategory}?climberId=${climberId}&route=${route}`,
  );
}

export async function updateScore({
  score,
  routeCategory,
}: {
  score: RouteScore;
  routeCategory: RouteCategory;
}): Promise<RouteScore> {
  return await post(`/score/${routeCategory}`, score);
}

export async function fetchResults(
  category?: ResultCategory,
): Promise<Results> {
  return await get(`/results${category ? `?category=${category}` : ''}`);
}

export async function login({
  email,
  password,
}: {
  email: string;
  password: string;
}) {
  return await post('/login', { email, password });
}

export async function logout() {
  return await post('/logout', {});
}

export async function fetchClimbers(): Promise<RegisteredClimber[]> {
  return await get('/climbers');
}

export async function updateClimber(climber: RegisteredClimber) {
  return await put('/climber', { climber });
}

export async function addClimber(climber: RegisteredClimber) {
  return await post('/climber', climber);
}

export async function addClub(name: string): Promise<{ name: string }> {
  return await post('/club', { name });
}

export async function getClubs(): Promise<string[]> {
  return await get('/clubs');
}

export async function addJudge({
  name,
  email,
}: {
  name: string;
  email: string;
}) {
  return await post('/users', { name, email });
}

export async function fetchUsers(): Promise<User[]> {
  return await get('/users');
}

export async function getRouteNumbers(): Promise<RouteNumbersConfig> {
  return await get('/routeNumbers');
}

export async function saveRoutesConfig(config: RouteNumbersConfig) {
  return await post('/routeNumbers', config);
}

export function exportUrl() {
  return `${API_BASE_URL}/exportResults`;
}
